import styled from 'styled-components';
import MenuButton from '@Shared/MenuButton';
import MenuDrawerItem from '@Shared/MenuDrawerItem';

export const StyledMenuDrawerItem = styled(MenuDrawerItem)`
  background-color: ${props => props.theme.carvana.white.primary};
`;
export const InnerDrawerItem = styled.div`
  flex: 1;
  max-height: ${props => (props.isExpanded ? 'unset;' : '30px;')};
  overflow: hidden;
  transition: max-height 200ms ease-out;
`;
export const StyledMenuButton = styled(MenuButton)`
  display: flex;
  flex: 1;
  text-transform: none;
  margin-top: 3px;

  &:hover {
    color: ${props => props.theme.carvana.blue.dark};
    text-decoration: none;
  }
`;
export const SvgWrapper = styled.span`
  height: 22px;
  width: 22px;
  margin-right: 10px;
`;
export const StyledAccountCircle = styled.div`
  fill: ${props => props.theme.carvana.blue.dark};
`;
export const DropdownWrapper = styled.div`
  color: ${props => props.theme.carvana.blue.dark};
`;
export const DropdownButton = styled(MenuButton)`
  display: flex;
  flex: 1;
  font-size: 12px;
  font-weight: 700;
  justify-content: flex-start;
  padding: 15px 0;
  text-decoration: none;
  letter-spacing: 0;

  &:last-child {
    padding-bottom: 0;
  }
`;
export const SignOut = styled(DropdownButton)`
  padding-top: 18px;
`;
export const ProfileName = styled.span`
  font-size: 16px;
  font-weight: 400;
  max-width: 81px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const GoogleOneTapForceSignoutWrapper = styled.div``;
